"use strict";

import { authConstants } from "./auth.constants";
import { lookupTableConstants } from "./lookupTable.constants";
import { factTableConstants } from "./factTable.constants";
import { incentiveConstants } from "./incentive.constants";
import { dataUploadConstants } from "./dataUpload.constants";
import { dataTemplateConstants } from "./dataTemplate.constants";
import { dashboardConstants } from "./dashboard.constants";
import { participantConstants } from "./participant.constants";

export const LOCATION_FROM = "LOCATION_FROM";

export const routeLocationLocalStorage = {
     HOME: "HOME",
     CAMPAIGN: "CAMPAIGN",
};

export const commonConstants = {
     AJAX_ERROR: "AJAX_ERROR",
     REFRESH_TOKEN_ERROR: "REFRESH_TOKEN_ERROR",
     AJAX_SUCCESS: "AJAX_SUCCESS",
     HIDE_AJAX_SUCCESS: "HIDE_AJAX_SUCCESS",

     HIDE_SUCCESS_SERVER_MESSAGE: "HIDE_SUCCESS_SERVER_MESSAGE",

     SHOW_ERROR_SERVER_MESSAGE: "SHOW_ERROR_SERVER_MESSAGE",

     HIDE_ERROR_SERVER_MESSAGE: "HIDE_ERROR_SERVER_MESSAGE",

     SHOW_SUCCESS_SERVER_MESSAGE: "SHOW_SUCCESS_SERVER_MESSAGE",

     TYPE_SUCCESS_MESSAGE: "TYPE_SUCCESS_MESSAGE",
     TYPE_ERROR_MESSAGE: "TYPE_ERROR_MESSAGE",

     ADD_PENDING_ACTIONS: "ADD_PENDING_ACTIONS",
     REMOVE_PENDING_ACTIONS: "REMOVE_PENDING_ACTIONS",

     IMAGE_UPLOAD_REQUEST: "IMAGE_UPLOAD_REQUEST",
     IMAGE_UPLOAD_COMPLETE: "IMAGE_UPLOAD_COMPLETE",
};

export const requestTypes = {
     REQUEST_TYPE_POST: "POST",
     REQUEST_TYPE_GET: "GET",
};

export const loadingSelectArray = [
     incentiveConstants.INCENTIVE_HEADER_CONTENT_ADD_REQUEST,
     incentiveConstants.INCENTIVE_HEADER_CONTENT_PUBLISH_REQUEST,

     //about campaign related
     incentiveConstants.INCENTIVE_ADD_ABOUT_CAMPAIGN_REQUEST,
     incentiveConstants.INCENTIVE_ABOUT_CONTENT_GET_REQUEST,
     incentiveConstants.INCENTIVE_ABOUT_CONTENT_PUBLISH_REQUEST,
     // end of about campaign related

     // start of quick content
     incentiveConstants.INCENTIVE_QUICK_CONTENT_ADD_REQUEST,
     incentiveConstants.INCENTIVE_QUICK_CONTENT_GET_REQUEST,
     incentiveConstants.INCENTIVE_QUICK_CONTENT_PUBLISH_REQUEST,
     // end of quick content

     // start of term content
     incentiveConstants.INCENTIVE_TERM_CONTENT_ADD_REQUEST,
     incentiveConstants.INCENTIVE_TERM_CONTENT_GET_REQUEST,
     incentiveConstants.INCENTIVE_TERM_CONTENT_PUBLISH_REQUEST,
     // end of term content

     // start of faq content
     incentiveConstants.INCENTIVE_FAQ_CONTENT_ADD_REQUEST,
     incentiveConstants.INCENTIVE_FAQ_CONTENT_PUBLISH_REQUEST,
     // end of faq content

     incentiveConstants.INCENTIVE_CONTENT_UNPUBLISH_REQUEST,

     authConstants.AUTH_LOGIN_REQUEST,
     authConstants.SEND_OTP_REQUEST,
     authConstants.RE_SEND_OTP_REQUEST,
     authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST,
     authConstants.FORGOT_PASSWORD_RESET_PASSWORD_REQUEST,
     authConstants.USER_DETAILS_REQUEST,

     lookupTableConstants.LOOKUP_TABLE_ADD_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_LIST_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_DELETE_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_GET_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_UPDATE_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_TYPES_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_ACTIVE_INACTIVE_REQUEST,

     lookupTableConstants.LOOKUP_TABLE_VALUE_ADD_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_VALUE_LIST_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_VALUE_DELETE_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_VALUE_GET_REQUEST,
     lookupTableConstants.LOOKUP_TABLE_VALUE_UPDATE_REQUEST,

     factTableConstants.FACT_TABLE_ADD_REQUEST,
     factTableConstants.FACT_TABLE_GET_REQUEST,
     factTableConstants.FACT_TABLE_LIST_REQUEST,
     factTableConstants.FACT_TABLE_DELETE_REQUEST,
     factTableConstants.FACT_TABLE_TYPES_REQUEST,
     factTableConstants.FACT_TABLE_UPDATE_REQUEST,

     incentiveConstants.INCENTIVE_TABLE_SEARCH_LIST_REQUEST,
     factTableConstants.FACT_TABLE_SCHEMA_VALUE_REORDER_REQUEST,
     factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_REQUEST,
     factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_TYPE_REQUEST,
     factTableConstants.FACT_TABLE_SCHEMA_VALUE_GET_REQUEST,
     factTableConstants.FACT_TABLE_SCHEMA_VALUE_DELETE_REQUEST,
     factTableConstants.FACT_TABLE_VALUE_ADD_REQUEST,
     factTableConstants.FACT_TABLE_VALUE_UPDATE_REQUEST,
     factTableConstants.FACT_TABLE_SCHEMA_VALUE_LIST_REQUEST,
     factTableConstants.FACT_TABLE_GET_VALUE_REQUEST,
     factTableConstants.FACT_TABLE_CREATE_BY_CSV_REQUEST,
     factTableConstants.GET_FACT_TABLE_JSON_SCHEMA_REQUEST,
     factTableConstants.ADD_FACT_TABLE_SCHEMA_RECORD_REQUEST,
     dataUploadConstants.DATA_FILE_TYPE_LIST_REQUEST,
     dataUploadConstants.DATA_FILE_SCHEMA_REQUEST,
     factTableConstants.DELETE_FACT_TABLE_SCHEMA_RECORD_REQUEST,
     factTableConstants.EDIT_FACT_TABLE_SCHEMA_RECORD_REQUEST,
     factTableConstants.GET_FACT_TABLE_SCHEMA_RECORD_REQUEST,
     dataUploadConstants.DATA_UPLOAD_ADD_REQUEST,

     dataTemplateConstants.DATA_TEMPLATE_LIST_REQUEST,
     dataTemplateConstants.GET_DATA_TEMPLATE_LABELS_REQUEST,
     dataTemplateConstants.GET_DATA_TEMPLATE_TYPES_REQUEST,
     dataTemplateConstants.GET_DATA_TEMPLATE_LABELS_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_DELETE_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_ADD_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_UPDATE_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_EDIT_SCHEMA_RECORD_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_GET_SCHEMA_RECORD_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_GET_VALUE_REQUEST,
     dataTemplateConstants.GET_DATA_TEMPLATE_JSON_SCHEMA_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_ADD_SCHEMA_VALUE_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_GET_REQUEST,
     dataTemplateConstants.DATA_TEMPLATE_GET_USER_ACCOUNT_REQUEST,

     incentiveConstants.INCENTIVE_TABLE_LIST_REQUEST,
     incentiveConstants.INCENTIVE_DELETE_REQUEST,
     incentiveConstants.INCENTIVE_TABLE_SEARCH_LIST_REQUEST,
     incentiveConstants.INCENTIVE_CHANGE_STATUS_REQUEST,
     incentiveConstants.GET_SALSE_DATA_TEMPLATE_REQUEST,
     incentiveConstants.GET_PARTICIPANT_DATA_TEMPLATE_REQUEST,
     incentiveConstants.UPDATE_ABOUT_CAMPAIGN_STEP_ONE_REQUEST,
     incentiveConstants.CREATION_STEP_ONE_REQUEST,
     incentiveConstants.LIST_CAMPAIGN_PARTICIPANTS_REQUEST,
     incentiveConstants.ADD_CAMPAIGN_PARTICIPANTS_REQUEST,
     incentiveConstants.ADD_CAMPAIGN_ADMINS_REQUEST,
     incentiveConstants.LIST_CAMPAIGN_ADMINS_REQUEST,

     // dashboardConstants.DASHBOARD_GET_DASHBOARD_SUMMARY_REQUEST,
     // dashboardConstants.DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_REQUEST,
     // dashboardConstants.DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_REQUEST,
     // dashboardConstants.DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_REQUEST,
     // dashboardConstants.DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_REQUEST,
     // dashboardConstants.DASHBOARD_GET_COMMS_PAGE_VIEW_REQUEST,
     // dashboardConstants.DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_REQUEST,
     // dashboardConstants.GET_DEVICED_USED_SUMMARY_REQUEST,
     // dashboardConstants.DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_REQUEST,

     // dashboardConstants.DASHBOARD_GET_Q4_OILMASTER_SUMMARY_REQUEST,
     // dashboardConstants.DASHBOARD_GET_WEAR_TEER_SUMMARY_REQUEST,
     // dashboardConstants.DASHBOARD_GET_ABUDAHBI_SUMMARY_REQUEST,

     participantConstants.PARTICIPANT_GET_APPLICATION_REQUEST,
     participantConstants.PARTICIPANT_GET_PARTICIPANT_SUMMARY_REQUEST,
     participantConstants.PARTICIPANT_GET_AREAS_REQUEST,
     participantConstants.PARTICIPANT_GET_DEALERS_REQUEST,
     participantConstants.PARTICIPANT_GET_JOB_ROLES_REQUEST,
     participantConstants.PARTICIPANT_UPDATE_PARTICIPANT_STATUS_REQUEST,
     participantConstants.PARTICIPANT_DELETE_REQUEST,
     participantConstants.PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_REQUEST
];

export const successMessagesList = [
     //about campaign related
     incentiveConstants.INCENTIVE_ADD_ABOUT_CAMPAIGN_COMPLETE,
     incentiveConstants.INCENTIVE_ABOUT_CONTENT_PUBLISH_COMPLETE,
     // end of about campaign related
     incentiveConstants.INCENTIVE_CONTENT_UNPUBLISH_COMPLETE,
     incentiveConstants.INCENTIVE_QUICK_CONTENT_ADD_COMPLETE,
     incentiveConstants.INCENTIVE_QUICK_CONTENT_PUBLISH_COMPLETE,
     incentiveConstants.INCENTIVE_TERM_CONTENT_ADD_COMPLETE,
     incentiveConstants.INCENTIVE_TERM_CONTENT_PUBLISH_COMPLETE,
     incentiveConstants.INCENTIVE_FAQ_CONTENT_ADD_COMPLETE,
     incentiveConstants.INCENTIVE_FAQ_CONTENT_PUBLISH_COMPLETE,
     factTableConstants.FACT_TABLE_CREATE_BY_CSV_COMPLETE,
     incentiveConstants.INCENTIVE_HEADER_CONTENT_PUBLISH_COMPLETE,
     dataUploadConstants.DATA_UPLOAD_ADD_COMPLETE,
     incentiveConstants.CREATION_STEP_ONE_COMPLETE,
     incentiveConstants.UPDATE_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE,
     incentiveConstants.ADD_CAMPAIGN_PARTICIPANTS_COMPLETE,
     incentiveConstants.ADD_CAMPAIGN_ADMINS_COMPLETE,

     authConstants.RE_SEND_OTP_COMPLETE,
     authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE,
     authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE,
     participantConstants.PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_COMPLETE,
];

export const errorResponseCodes = {
     504: "Couldn't connect to server, Please try again.",
};

export const responseCodes = {
     SUCCESS_CODE: "00",
     _CODE: "401",
};

export const contextApiActions = {
     UI_CONFIRMATION_TOGGEL: "UI_CONFIRMATION_TOGGEL",
     UI_MODAL_TOGGEL: "UI_MODAL_TOGGEL",
     UI_LARGE_MODAL_TOGGEL: "UI_LARGE_MODAL_TOGGEL",
     UI_EXTRA_LARGE_MODAL_TOGGEL: "UI_EXTRA_LARGE_MODAL_TOGGEL",
     UI_ERROR_MESSAGE_TOGGEL: "UI_ERROR_MESSAGE_TOGGEL",
     UI_SUCCESS_MESSAGE_TOGGEL: "UI_SUCCESS_MESSAGE_TOGGEL",

     SET_SIGNALR_CONNECTTION: "SET_SIGNALR_CONNECTTION",
};

export const frontEndSuccessMessages = {
     //about campaign related
     [incentiveConstants.INCENTIVE_ADD_ABOUT_CAMPAIGN_COMPLETE]:
          "About Campaign created successfully",
     [incentiveConstants.INCENTIVE_ABOUT_CONTENT_PUBLISH_COMPLETE]:
          "About Campaign published successfully",
     // end of about campaign related

     // start quick read
     [incentiveConstants.INCENTIVE_QUICK_CONTENT_ADD_COMPLETE]:
          "Quick Read created successfully",
     [incentiveConstants.INCENTIVE_QUICK_CONTENT_PUBLISH_COMPLETE]:
          "Quick Read Campaign published successfully",
     // end quick read

     // start term content
     [incentiveConstants.INCENTIVE_TERM_CONTENT_ADD_COMPLETE]:
          "Term & Condition created successfully",
     [incentiveConstants.INCENTIVE_TERM_CONTENT_PUBLISH_COMPLETE]:
          "Term & Condition Campaign published successfully",
     // end term content

     // start faq content
     [incentiveConstants.INCENTIVE_FAQ_CONTENT_ADD_COMPLETE]:
          "FAQ created successfully",
     [incentiveConstants.INCENTIVE_FAQ_CONTENT_PUBLISH_COMPLETE]:
          "FAQ published successfully",
     // end faq content

     [incentiveConstants.INCENTIVE_CONTENT_UNPUBLISH_COMPLETE]:
          "Campaign Content unpublished successfully",

     [factTableConstants.FACT_TABLE_CREATE_BY_CSV_COMPLETE]:
          "Fact table created successfully",
     [incentiveConstants.INCENTIVE_HEADER_CONTENT_PUBLISH_COMPLETE]:
          "Header content published successfully",
     [dataUploadConstants.DATA_UPLOAD_ADD_COMPLETE]:
          "Data File Queued Successfully",
     [incentiveConstants.CREATION_STEP_ONE_COMPLETE]:
          "Campaign created Successfully",
     [incentiveConstants.UPDATE_ABOUT_CAMPAIGN_STEP_ONE_COMPLETE]:
          "Campaign updated Successfully",
     [incentiveConstants.ADD_CAMPAIGN_PARTICIPANTS_COMPLETE]:
          "Participants  updated Successfully",

     [incentiveConstants.ADD_CAMPAIGN_ADMINS_COMPLETE]:
          "Admins  updated Successfully",

     [authConstants.RE_SEND_OTP_COMPLETE]: "OTP sent Successfully",
     [authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE]:
          "Email sent successfully!",

     [authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE]:
          "Your password changed successfully!",
     [participantConstants.PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_COMPLETE]:
          "Activation send successfully!"     
};

export const signalrTopics = {
     DATA_UPLOAD_STATUS_CHANGE: "data-upload-status-change",
     DATA_UPLOAD_RECORD_CHANGE: "data-upload-record-change",
};

export const FILE_UPLOAD_URL = process.env.FILE_UPLOAD_BASE_URL;
export const KENDO_REPORTING_URL = process.env.KENDO_REPORTING_URL;
